import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { Navigate, Outlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getUser, selectUser } from "../../redux/modules/userSlice";
import { UserAPI } from "../api";
import { AUTH_COLORS } from "../../config/authConstants";
import { isNewJoineeFormSubmitted } from "../../config/joineeConstants";

/**
 * Route gate for the 6 forms after the New Joinee Form. The stored user can be
 * stale right after submitting, so a locked state is re-checked with the server.
 */
function RequireNewJoineeForm() {
  var dispatch = useDispatch();
  var { user } = useSelector(selectUser);
  var unlockedInStore =
    Boolean(user && (user.isAdmin || user.isSuperAdmin)) ||
    isNewJoineeFormSubmitted(user && user.isNewJoineeFormComplete);
  var [state, setState] = useState(unlockedInStore ? "allowed" : "checking");

  useEffect(
    function () {
      if (unlockedInStore || !user || !user._id) {
        if (!unlockedInStore) setState("blocked");
        return undefined;
      }
      var active = true;
      UserAPI.getUser(user._id)
        .then(function (res) {
          if (!active) return;
          var data = res && res.data ? res.data : res;
          if (data && isNewJoineeFormSubmitted(data.isNewJoineeFormComplete)) {
            dispatch(getUser(Object.assign({}, user, data)));
            setState("allowed");
          } else {
            setState("blocked");
          }
        })
        .catch(function () {
          if (active) setState("blocked");
        });
      return function () {
        active = false;
      };
    },
    [unlockedInStore, user && user._id]
  );

  useEffect(
    function () {
      if (state === "blocked") {
        toast.info("Please submit the New Joinee Form first to unlock this form.", {
          hideProgressBar: true,
          closeOnClick: true,
          toastId: "joinee-form-locked",
        });
      }
    },
    [state]
  );

  if (state === "allowed") return <Outlet />;
  if (state === "blocked") return <Navigate to="/" replace />;
  return (
    <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
      <CircularProgress sx={{ color: AUTH_COLORS.primary }} />
    </Box>
  );
}

export default RequireNewJoineeForm;
